import { SdkFunctionWrapper } from './generated/requests'

// SSR-safe utility functions
const getFingerprint = async () => {
  try {
    const { getFingerprint: getFingerprintUtil } = await import('src/components/CustomHooks/useFingerprint')
    return await getFingerprintUtil()
  } catch (error) {
    return null
  }
}

const getIPFromRequest = async () => {
  try {
    const { getIPAddress: getIPFromRequestUtil } = await import('src/components/CustomHooks/useIPAddress')
    return await getIPFromRequestUtil()
  } catch (error) {
    return null
  }
}

const getEncodedUniqueId = async () => {
  try {
    const { getEncodedUniqueId: getEncodedUniqueIdUtil } = await import('src/components/CustomHooks/useUniqueId')
    return await getEncodedUniqueIdUtil()
  } catch (error) {
    return null
  }
}



export const createEnhancedLoggingWrapper = (request?: any): SdkFunctionWrapper => {
  return <T>(
    action: (requestHeaders?: Record<string, string>) => Promise<T>,
    operationName: string,
    operationType?: string,
    variables?: any,
  ): Promise<T> => {
    const startTime = Date.now()
    const requestId = Math.random().toString(36).substring(7)
    
    // Enhanced wrapper that adds headers
    const enhancedAction = async (wrappedRequestHeaders?: Record<string, string>) => {
      const headerStartTime = Date.now()
      const headers: Record<string, string> = {
        ...wrappedRequestHeaders
      }
      
      try {
        // Get fingerprint
        const fingerprintStart = Date.now()
        const fingerprint = await getFingerprint()
        const fingerprintDuration = Date.now() - fingerprintStart
        
        // Get IP address using the new getIPFromRequest function
        const ipStart = Date.now()
        let ipAddress = await getIPFromRequest()
        const ipDuration = Date.now() - ipStart
        
        // Always generate new encoded unique ID (uses timestamp)
        const uniqueIdStart = Date.now()
        const encodedUniqueId = await getEncodedUniqueId()
        const uniqueIdDuration = Date.now() - uniqueIdStart
        
        // Add enhanced headers
        if (fingerprint) {
          headers['X-Fingerprint-ID'] = fingerprint
        }
        
        if (ipAddress) {
          headers['X-IP-Address'] = ipAddress
        }
        
        if (encodedUniqueId) {
          headers['X-Request-ID'] = encodedUniqueId
        }
        
        const headerGenerationDuration = Date.now() - headerStartTime
        
        // Format timestamp
        const timestamp = new Date().toISOString().replace('T', ' ').replace('Z', '')
        
        // Get HTTP method and URL from the request context
        const httpMethod = request?.method || 'POST'
        const url = request?.url || '/graphql'
        
        // Log in the desired format
        // eslint-disable-next-line no-console
        if (typeof window === 'undefined') {
          console.info(`custom wrapper [${timestamp}] http: ${httpMethod} ${url} ${operationName} (${Date.now() - startTime} ms) 200 {
              'Ip Address': '${ipAddress || 'N/A'}',
              'Request ID': '${encodedUniqueId || 'N/A'}',
              'Fingerprint': '${fingerprint || 'N/A'}',
              'Operation': '${operationName}'
            }`
          )
        }
        // Log timing information only if it takes longer than expected
        // if (headerGenerationDuration > 0) { // Log if header generation takes more than 100ms
        //   console.warn(1, `[GraphQL:${requestId}] Slow header generation for ${operationName}:`, {
        //     totalHeaderTime: `${headerGenerationDuration}ms`,
        //     fingerprintTime: `${fingerprintDuration}ms`,
        //     ipTime: `${ipDuration}ms`,
        //     uniqueIdTime: `${uniqueIdDuration}ms`,
        //     operationType
        //   }, {
        //     fingerprint,
        //     ipAddress,
        //     encodedUniqueId
        //   })

        // }
        
      } catch (error) {
        const headerGenerationDuration = Date.now() - headerStartTime
        // eslint-disable-next-line no-console
        console.error(`[GraphQL:${requestId}] Failed to add enhanced headers after ${headerGenerationDuration}ms:`, error)
      }
      
      // Execute the original action with enhanced headers
      const actionStartTime = Date.now()
      return action(headers).then(
        (result) => {
          const actionDuration = Date.now() - actionStartTime
          const totalDuration = Date.now() - startTime
          return result
        },
        (error) => {
          const actionDuration = Date.now() - actionStartTime
          const totalDuration = Date.now() - startTime
          
          // eslint-disable-next-line no-console
          console.error(`[GraphQL:${requestId}] ${operationName} failed after ${totalDuration}ms:`, {
            totalTime: `${totalDuration}ms`,
            actionTime: `${actionDuration}ms`,
            headerTime: `${totalDuration - actionDuration}ms`,
            operationType,
            error: error.message
          })
          
          throw error
        }
      )
    }
    
    return enhancedAction()
  }
}

